import React from 'react';

    const Logo = ({ className = 'h-8' }) => {
      return (
        <img 
          src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1761300147148-Togethr%201.png"
          alt="Togethr Logo"
          className={className}
        />
      );
    };

    export default Logo;